/* 
 * Safely get something from nested objects returning the default
 * if it doesn't exist
 */
export default function so(obj, path, defaultValue) {
  let fields = path.split('.');
  let i = obj;
  while (typeof(i) == 'object' && i !== null && fields.length > 0) {
    i = i[fields[0]];
    fields.shift();
  }
  if (fields.length === 0 && typeof(i) !== 'undefined') {
    return(i);
  }
  return(defaultValue);
}
